import React from 'react';

import './back_link.scss';

interface BackLinkProps {
  handleClick: React.MouseEventHandler<HTMLDivElement>;
  label?: string;
}

export const BackLink: React.FC<BackLinkProps> = ({ handleClick, label = 'Назад' }) => (
  <div className="back-link-container">
    <div className="back-link" onClick={handleClick}>
      {label}
    </div>
  </div>
);
